// removed by extract-text-webpack-plugin
module.exports = {"icon":"index_17G9L9M","content":"index_2NiKJb-","title":"index_3OLZauH","title2":"index_2qOZBHi","contact":"index_2agcdE9","small_icon":"index_3ujwBk9"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/about/index.css
// module id = 1054
// module chunks = 0